import { getContext, setContext } from "svelte";
const contextKey = Symbol("InstantSearch:instantSearchContext");
export function setInstantSearchContext(instantSearch) {
    setContext(contextKey, instantSearch);
}
export function getInstantSearchContext() {
    return getContext(contextKey);
}
